import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.TwoFaEnablingWizard.StepSuccess', {
    title: 'Two-factor authentication has been enabled',
    description:
        'All done! From now on, you’ll need your password as well as an additional authentication method for logging into ApprovalMax.',
    button: 'Done',
});
